import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { RISK_COLOR_CLASS } from '@nk/utils-lib';
import { getNetworkRiskGroup } from '../utils/network-risk-score.utils';

@Pipe({
  name: 'networkRiskScoreRiskColorClass',
})
@Injectable()
export class NetworkRiskScoreRiskColorClassPipe implements PipeTransform {
  public transform(value: number): string {
    return RISK_COLOR_CLASS[getNetworkRiskGroup(value)];
  }
}
